import { useLocation, useNavigate } from 'react-router-dom'
import { mutate } from 'swr'

import { IncomeSource } from '@frame/components/screens/tasks/screens/strategies/documents/types'
import { DirectTask, TrueworkJsStrategy } from '@frame/lib/api/tasks/types'
import { routes } from '@frame/routes'

import { useRootContext } from '../context'
import { useStrategies } from './useStrategies'

export function useVerifyViaDocuments(): (task?: DirectTask, employerName?: string) => Promise<void> {
  const navigate = useNavigate()
  const location = useLocation()
  const { api } = useRootContext()
  const { actions } = useRootContext()
  const { credentialsEnabled } = useStrategies()

  const params = new URLSearchParams(location.search)

  async function verify(selectDirectTask?: DirectTask, employerName?: string) {
    let directTask = selectDirectTask
    if (!selectDirectTask) {
      const newTask = await actions.createDirectTask({
        employer_name: employerName ?? null,
        income_source: credentialsEnabled ? undefined : IncomeSource.OTHER_INCOME,
      })
      if (!newTask) {
        throw new Error('Failed to create task')
      }
      directTask = await actions.addStrategyToDirectTask({
        directTaskId: newTask.id,
        strategy: TrueworkJsStrategy.DOCUMENTS,
      })
      mutate(['all', 'tasks'])
    } else {
      directTask = await actions.addStrategyToDirectTask({
        directTaskId: selectDirectTask?.id,
        strategy: TrueworkJsStrategy.DOCUMENTS,
      })
    }

    if (directTask) {
      await api.tasks.verifyTask(directTask.id)
    }

    navigate(`${routes.documents}/${directTask?.id}?${params.toString()}`, {
      state: { task: directTask },
    })
  }

  return verify
}
